import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useAuth from '../../hooks/useAuth';

// Persistent banner shown at the top of the app whenever the admin is
// acting as another user. Writes go through view-as too, so this is a
// load-bearing visual cue — keep it loud.
const ViewAsBanner = () => {
  const { viewingAs, exitViewAs } = useAuth();
  if (!viewingAs) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        bgcolor: '#b85c00',
        color: '#fff',
        py: 0.75,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      }}
    >
      <VisibilityIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Acting as {viewingAs.name || viewingAs.email}
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.9 }}>
        ({viewingAs.email}) — every request is audit-logged
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Button
        size="small"
        variant="contained"
        onClick={exitViewAs}
        sx={{
          bgcolor: '#fff',
          color: '#b85c00',
          fontWeight: 600,
          '&:hover': { bgcolor: '#fff', opacity: 0.9 },
        }}
      >
        Exit view-as
      </Button>
    </Box>
  );
};

export default ViewAsBanner;
